import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugLogActions } from "../helpers/debugHelper";

export const startLoadingRuleFlowsByRoleAndModule = (role_id, module_id, extras = {}) => {
  return async (dispatch) => {
    const query = new URLSearchParams(
      Object.entries(extras).filter(([, value]) => value !== '' && value !== null && value !== undefined)
    ).toString();
    const suffix = `getByRoleAndModule/${role_id}/${module_id}${query ? `?${query}` : ''}`;
    dispatch(loadingRuleFlowsByRoleAndModule([]));
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_RULE_FLOW}`,
        suffix);

      const body = await resp.json();

      debugLogActions(':: ruleFlowActions, startLoadingRuleFlowsByRoleAndModule', { 'body': body });

      if (body.ok) {
        dispatch(loadingRuleFlowsByRoleAndModule(body.ruleFlows));
        return;
      }

      dispatch(loadingRuleFlowsByRoleAndModule([]));
      if (body.code === "bak-error-001") {
        Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
        Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    } catch (error) {
      debugLogActions(':: ruleFlowActions, startLoadingRuleFlowsByRoleAndModule', { error });
      dispatch(loadingRuleFlowsByRoleAndModule([]));
    }
  };
};

const loadingRuleFlowsByRoleAndModule = (ruleFlows) => ({
  type: types.RULEFLOW_START_LOADING,
  payload: ruleFlows,
});

export const startLoadingRuleFlowsByModule = (module_id) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`, 
      `${const_routes.VERSIONV1}`, 
      `${const_routes.ROUTE_RULE_FLOW}`, 
      `getByModule/${module_id}`);

    const body = await resp.json();

     debugLogActions(':: ruleFlowActions, startLoadingRuleFlowsByModule', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingRuleFlowsByModule(body.ruleFlows));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingRuleFlowsByModule = (ruleFlows) => ({
  type: types.RULEFLOW_BY_MODULE_START_LOADING,
  payload: ruleFlows,
});